(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaSnomedDetailController', RcopiaSnomedDetailController);

    RcopiaSnomedDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RcopiaSnomed'];

    function RcopiaSnomedDetailController($scope, $rootScope, $stateParams, previousState, entity, RcopiaSnomed) {
        var vm = this;

        vm.rcopiaSnomed = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bluebookApp:rcopiaSnomedUpdate', function(event, result) {
            vm.rcopiaSnomed = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
